<script setup lang="ts">
import EventRoomOne from "@/views/event-activities/components/EventRoomOne.vue";
// import EventRoomTwo from "@/views/event-activities/components/EventRoomTwo.vue";
// import EventRoomThree from "@/views/event-activities/components/EventRoomThree.vue";
import {defineProps} from "vue";
const props = defineProps(
    {
      eventPresentation:[]
    }
  );
console.log(props.eventPresentation)
</script>

<template>
  <div class="impx-features-tab uk-padding uk-padding-remove-top uk-padding-remove-horizontal uk-margin-medium-top  uk-width-1-1">
    <ul class="impx-ft-tab-items  uk-position-top uk-margin-auto-left uk-margin-bottom" data-uk-tab><!-- tab menus -->
      <li class="uk-active uk-margin-small-bottom" v-for="(eventItem,index) in props.eventPresentation" :key="index"><a href="#"><i class="fa fa-home" >
      </i>{{eventItem?.title??''}}</a>
      </li><!-- tab menu #1-->
    </ul>
    <ul id="features-tab-content uk-margin-top" class="uk-switcher impx-negative-top small uk-padding uk-padding-remove-bottom  uk-margin-small-bottom uk-margin-large-top">
      <li class="tab-item" v-for="(eventItemContent,index) in props.eventPresentation" :key="index"><!--  tab content #1 -->
        <div class="uk-grid">
          <div class="uk-width-1-3@xl uk-width-1-3@l uk-width-1-1@m">
            <h3 class="uk-margin-bottom">{{eventItemContent?.subtitle??''}}</h3>
            <p>{{eventItemContent?.description??''}}</p>
            <p class="mobile-mb"> {{eventItemContent?.description??''}}</p>
          </div>
          <div class="uk-width-2-3@xl uk-width-2-3@l uk-width-1-1@m  uk-width-1-1@s">
            <div class="uk-grid uk-grid-medium impx-margin-top impx-margin-top-m">
              <div class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-2@m uk-width-1-2@s  mobile-mb impx-margin-bottom-medium"
                   v-for="(imgEventItem,index) in eventItemContent.eventImages??[]" :key="index"
              >
                <img :src="imgEventItem?.url??''" alt="{{imgEventItem.name}}">
              </div>

            </div>
          </div>
        </div>

      </li><!--  tab content #1 end -->
<!--      <li class="tab-item">&lt;!&ndash;  tab content #2 &ndash;&gt;-->
<!--        <event-room-two></event-room-two>-->
<!--      </li>&lt;!&ndash;  tab content #2 end &ndash;&gt;-->
<!--      <li class="tab-item">&lt;!&ndash;  tab content #4 &ndash;&gt;-->
<!--        <event-room-three></event-room-three>-->
<!--      </li>&lt;!&ndash;  tab content #4 end &ndash;&gt;-->
    </ul>
    <event-room-one></event-room-one>

  </div>
</template>

<style scoped>

</style>